import type { FormType } from "../../types";

type Args = {
	shouldRedirectToDashboard?: boolean;
	pathname: string;
	setOpenModal: (modal: FormType | null) => void;
	navigate: (path: string) => void;
};
export function onSuccessUpdate(args: Args) {
	const {
		setOpenModal,
		navigate,
		shouldRedirectToDashboard = true,
		pathname,
	} = args;

	if (shouldRedirectToDashboard && pathname !== "/dashboard") {
		navigate("/dashboard");
	}

	setOpenModal(null);
}

export type OnSuccessUpdateFnType = typeof onSuccessUpdate;
